import { render } from "./My.vue?vue&type=template&id=5c3f0bfb&scoped=true"
import script from "./My.vue?vue&type=script&lang=js"
export * from "./My.vue?vue&type=script&lang=js"

import "./My.vue?vue&type=style&index=0&id=5c3f0bfb&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17630037586\\Desktop\\新建文件夹 (2)\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3f0bfb"]])

export default __exports__